module.exports = __webpack_public_path__ + "static/media/trackimage.4465981f.png";